import type {
  ActivateCreateFormAction,
  CreateCustomKeyIssueDefaultAction,
  CreateCustomKeyIssueFulfilledAction,
  CreateCustomKeyIssueRejectedAction,
} from "domains/customKeyIssue/actionTypes";
import { CustomKeyIssueTypes } from "domains/customKeyIssue/actionTypes";

export const createCustomKeyIssue = (
  meta: CreateCustomKeyIssueDefaultAction["meta"],
): CreateCustomKeyIssueDefaultAction => ({
  type: CustomKeyIssueTypes.CREATE,
  meta,
});

export const createCustomKeyIssueSuccess = (dimensionId?: string): CreateCustomKeyIssueFulfilledAction => ({
  payload: { dimensionId },
  type: CustomKeyIssueTypes.CREATE_FULFILLED,
});

export const createCustomKeyIssueFailure = (): CreateCustomKeyIssueRejectedAction => ({
  type: CustomKeyIssueTypes.CREATE_REJECTED,
});

export const toggleCustomKeyIssueForm = (meta?: ActivateCreateFormAction["meta"]): ActivateCreateFormAction => ({
  type: CustomKeyIssueTypes.ACTIVATE_FORM,
  meta,
});
